import "./way_type.css";
export default function WayType({ type }: { type: string }) {
  return <div className={`type-${type}`}>{type?.toUpperCase() || "-"}</div>;
}
